// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletButton_container__1AS1-","wallet_name":"WalletButton_wallet_name__2Djyu"};